import { OperationVariables } from "@apollo/client";
import { createContext, useContext } from "react";
import { Agencia } from "types";
export interface AgenciaContextType {
  agencia: Agencia;
  loading: boolean;
  error: Error | null;
  refetch: (variables?: Partial<OperationVariables>) => Promise<any>;
}

export interface AgenciaData {
  agencia: Agencia;
}

export const AgenciaContext = createContext<AgenciaContextType>(null);

export const useAgenciaContext = () => {
  return useContext(AgenciaContext);
};
